import { render, staticRenderFns } from "./ReceiptLogsTable.vue?vue&type=template&id=0bf20730"
import script from "./ReceiptLogsTable.vue?vue&type=script&lang=js"
export * from "./ReceiptLogsTable.vue?vue&type=script&lang=js"
import style0 from "./ReceiptLogsTable.vue?vue&type=style&index=0&id=0bf20730&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports